<div class="pagination u-border-top" *ngIf="totalPages > 1">
  <div class="c-button__group">
    <button
      class="o-button o-button--default o-button--medium o-button--icon"
      (click)="goToPage(1)"
      *ngIf="showFirstLast"
      [disabled]="isFirstPage(currentPage)"
    >
      <i class="fa fa-step-backward" aria-hidden="true"></i>
    </button>
    <button
      class="o-button o-button--default o-button--medium o-button--icon"
      (click)="goToPage(currentPage - 1)"
      *ngIf="showNextPrevious"
      [disabled]="isFirstPage(currentPage)"
    >
      <i class="fa fa-backward" aria-hidden="true"></i>
    </button>
  </div>
  <div class="c-button__group">
    <button
      *ngFor="let i of pages"
      class="o-button o-button--default o-button--medium o-button--icon"
      [class.o-button--active]="i === currentPage"
      (click)="goToPage(i)"
    >
      {{ i }}
    </button>
  </div>
  <div class="c-button__group">
    <button
      class="o-button o-button--default o-button--medium o-button--icon"
      (click)="goToPage(currentPage + 1)"
      *ngIf="showNextPrevious"
      [disabled]="isLastPage(currentPage)"
    >
      <i class="fa fa-forward" aria-hidden="true"></i>
    </button>
    <button
      class="o-button o-button--default o-button--medium o-button--icon"
      (click)="goToPage(totalPages)"
      *ngIf="showFirstLast"
      [disabled]="isLastPage(currentPage)"
    >
      <i class="fa fa-step-forward" aria-hidden="true"></i>
    </button>
  </div>
</div>
